import React from 'react';

import MessageSkeleton from './MessageSkeleton';

export default function PharmacyMessage(props) {
  /** message schema
		{
			Message: string
			Type: number
		}
	*/
  const { message } = props;

  return <MessageSkeleton renderMessage={() => message.Message} />;
}
